/* eslint-disable no-invalid-this */
/* eslint-disable no-unused-vars */
/* global _TL_ */
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import Promise from 'bluebird';
import { ThemeProvider } from 'react-jss';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import dataModelUtil from '@bingads-webui-campaign-legacy/adextension-image/util/dataModelConvert';
import { DisclaimerAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';
import { isCampaignEditorialError } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';
import pageContext from '@bingads-webui-static-legacy/page-context';
import summaryDataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import { Repository } from '@bingads-webui-campaign-legacy/adextension-image/service/repository';
import { ResponsiveSearchAdEditor, formatRSAObject } from '@bingads-webui-campaign-react/responsive-search-ad-editor';
import { AdStrengthRepository } from '@bingads-webui-campaign-react/responsive-search-ad-suggestion';
import { ImageExtensionsPane } from '@bingads-webui-campaign-react/image-extensions-pane';
import { instrumentationScenarios } from '@bingads-webui-campaign/ad-creator-tools-instrumentation';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { mergeI18n } from '@bingads-webui-campaign-react/i18n-merger';
import { PreferenceService } from '@bingads-webui/preference-service';
import { getTabbableNodes } from '@bingads-webui-react/focus-lock';

// [TODO] need update
const fieldMapping = {
  'DisplayUrl': 'Path1',
  'DestinationUrl': 'FinalUrls',
};

const inlineErrorFields = [
  'Headlines',
  'Descriptions',
  'FinalUrls',
  'DisplayUrl',
  'Path1',
  'Path2',
  'MobileFinalUrls',
  'TrackingUrlTemplate',
  'FinalUrlSuffix',
  'UrlCustomParameters',
  'Headline0',
  'Headline1',
  'Headline2',
  'Headline3',
  'Headline4',
  'Headline5',
  'Headline6',
  'Headline7',
  'Headline8',
  'Headline9',
  'Headline10',
  'Headline11',
  'Headline12',
  'Headline13',
  'Headline14',
  'Description0',
  'Description1',
  'Description2',
  'Description3',
];

export default class View extends Backbone.View {
  /**
   * Initialize ad editor to create ad.
   *
   * @param {Object} options - options with data to initialize the editor.
   *
   * @param {Object} options.model - Backbone.Model with the model information of an existing ad,
   * used get the data to edit existing ad.
   *
   * @param {function} options.scope - gets the scope, used to get the campaign and adgroup ids.
   *
   * @return {Promise} - Promise of save request.
   */
  initialize({
    scope,
    editMode = false,
    model = {},
    showInline = false,
    instrumentation,
    perfMarker,
    timeZone,
    permissions,
    serverContext,
    logActivity = _.noop,
    activityLogger,
    externalCachedImageExtensionChanges,
    onCachedImageExtensionChanged,
    showImgExtWithoutAdGroupID = false,
    preferenceService,
  }) {
    this.preferenceService = preferenceService;
    this.ad = { data: cloneDeep(model) || {} };
    this.editMode = editMode;
    this.showInitialErrors = !_.isEmpty(model);
    this.showInline = showInline;
    this.cachedAd = {};
    this.apiErrors = [];
    this.viewModel = {
      errors: () => this.apiErrors,
    };
    this.showImgExtWithoutAdGroupID = !!permissions.dynamic.RSAImageExtInAdGroupCreation && showImgExtWithoutAdGroupID;
    this.adStrengthRepository = new AdStrengthRepository({ edm, jsdata });

    this.instrumentation = instrumentation;
    this.onCachedImageExtensionChanged = onCachedImageExtensionChanged;

    if (perfMarker) {
      this.perfMarker = perfMarker.createChild('ResponsiveSearchAdEditor', { autoEnd: true });
    }

    this.timeZone = timeZone;
    this.permissions = permissions;
    this.logActivity = logActivity;
    this.scope = scope;
    this.returnSuggestionIds = [];
    this.applySuggestionIds = [];
    this.viewSuggestionIds = [];
    this.logAppliedSuggestionsFunc = _.noop;
    this.assetLibraryEventHandler = {};
    this.clickViewIdeas = [];
    this.serverContext = serverContext;
    this.extensionsSharedRepos = new SharedRepository({
      schema: DisclaimerAdExtension,
      afterChangeComitted: _.noop,
    });
    this.scope.subscribe(() => {
      if (this.scope().adGroupId != null) {
        this.render();
      }
    }, this);
    this.activityLogger = activityLogger;

    this.enableRSAExpansion =
      !!permissions.dynamic.RSAImageExtInAdGroupCreation ||
      !!permissions.dynamic.RSAImageExtInCampaignCreation ||
      this.showInline;

    this.cid = config.get('CurrentAccount') ? config.get('CurrentAccount').AdvertiserCustomerID : config.get('advertiserCustomerID');
    this.aid = _.result(config.get('CurrentAccount'), 'Id');
    this.adContext = {
      advertiserCustomerId: this.cid,
      accountId: this.aid,
    };

    if (this.enableRSAExpansion) {
      this.imageExtRepository = new Repository({
        schema: window.globalLegacySchema.get('ImageAdExtension'),
        afterChangeComitted: () => {
          summaryDataContextManager.updateContext(['AdGroupAdExtensionsGrid']);
        },
      });
      this.imageExtRepository.association.createRequestFactory('adgroup');
      // AddImage component is using both new i18n and old i18n resource data, so need to merge.
      this.legacyI18n = mergeI18n(
        window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/audience-campaign'),
        this.options.newI18n,
      );

      this.theme = config.get('theme');

      this.oDataConfig = {
        odataRootUrl: config.get('CampaignAzureDomain'),
        odataPath: config.get('odata.url') + config.get('odata.path'),
        odataToken: config.get('odata.token'),
      };

      this.cachedImageExtensionChanges = externalCachedImageExtensionChanges ? externalCachedImageExtensionChanges : {
        current: [],
        added: [],
        removed: [],
        updated: [],
      };

      this.maxImageExtensionsPerAdGroup = config.get('Feature').AdExtension.MaxSelectedImagesPerAdGroupOrCampaignForV2;
      this.dateFormat = _.get(pageContext, ['CurrentUser', 'CultureDateTimeFormat', 'ShortDatePattern']);
      this.timeZone = _.get(pageContext, ['CurrentAccount', 'TimeZone']);
    }
  }

  updateSuggestionMeasurement({
    returnSuggestionIds,
    applySuggestionIds,
    viewSuggestionIds,
    clickViewIdeas,
  }) {
    if (returnSuggestionIds && returnSuggestionIds.length > 0) {
      this.returnSuggestionIds = _.uniq(this.returnSuggestionIds.concat(returnSuggestionIds));
    }
    if (applySuggestionIds && applySuggestionIds.length > 0) {
      this.applySuggestionIds = _.uniq(this.applySuggestionIds.concat(applySuggestionIds));
    }
    if (viewSuggestionIds && viewSuggestionIds.length > 0) {
      this.viewSuggestionIds = _.uniq(this.viewSuggestionIds.concat(viewSuggestionIds));
    }
    if (clickViewIdeas && clickViewIdeas.length > 0) {
      this.clickViewIdeas = _.uniq(this.clickViewIdeas.concat(clickViewIdeas));
    }
  }

  saveLogAppliedSuggestionsFunc(func) {
    this.logAppliedSuggestionsFunc = func;
  }

  saveAssetLibraryEventHandler(eventHandler) {
    this.assetLibraryEventHandler = eventHandler;
  }

  fetchAdStrengthV2(ad, campaignId, adGroupId) {
    return this.adStrengthRepository.fetchAdStrengthV2(ad, campaignId, adGroupId);
  }

  fetchDisclaimerInfo() {
    if (this.scope().campaignId != null && this.scope().adGroupId !== null && this.permissions.IsDisclaimerForRSAEnabled) {
      let params = {
        queryParameters: {
          entitySet: edm.currentAccount.Campaigns,
        },
        bypassCache: true,
      };

      return jsdata.Campaign.find(this.scope().campaignId, params)
        .then((data) => {
          const hasDisclaimer = _.result(_.find(data.CampaignSettings, (setting) => {
            return setting['@odata.type'] === '#Model.DisclaimerSetting';
          }), 'DisclaimerAdsEnabled');

          if (hasDisclaimer) {
            const scope = Object.create({
              campaignId: this.scope().campaignId,
            });

            return this.extensionsSharedRepos.association.findAll({
              where: scope,
            }).then((disclaimerdata) => {
              if (disclaimerdata && disclaimerdata.length > 0) {
                return {
                  hasDisclaimer: true,
                  disclaimerData: disclaimerdata[0],
                };
              }
              return { hasDisclaimer: false };
            });
          }
          return { hasDisclaimer: false };
        });
      // TODO : catch and finally
    }
    return Promise.resolve({ hasDisclaimer: false });
  }

  focusErrorFocusableElement(targetError) {
    const panel = targetError.closest('.collapse-panel');

    if (!panel) {
      return;
    }

    const focusableElements = getTabbableNodes(panel);

    if (focusableElements && focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }

  validate() {
    this.showInitialErrors = true;
    if (!_.isEmpty(this.cachedAd.data) && !this.cachedAd.incomplete && _.filter(this.cachedAd.errorFields, (errorField) => _.includes(inlineErrorFields, errorField)).length === 0) {
      return true;
    }

    // this.render({ onFirstErrorHandler: this.focusErrorFocusableElement });
    this.render();

    this.logActivity(JSON.stringify(this.cachedAd.errors), 'responsive search ad editor');
    return false;
  }

  resetEditMode(mode) {
    this.editMode = mode;
    this.showInitialErrors = this.editMode;
  }

  toObject() {
    const params = _.omit(formatRSAObject(this.cachedAd.data), this.permissions.IsVanityUrlEnabled ? [] : ['DisplayUrl']);
    const api = this.showInline ? 'odata' : 'bulk';
    const arrayEmptyValue = api === 'odata' ? [] : null;
    const stringEmptyValue = api === 'odata' ? '' : null;

    // bulk API needs use 'delete_vlaue' to indicate deleting a value, in jsdata bulk adapter, we will replace null with 'delete_value' to remove value
    if (this.editMode) {
      const nullableArrayFields = [
        'FinalUrls',
        'MobileFinalUrls',
        'UrlCustomParameters',
      ];

      const nullableStringFields = _.compact([
        'TrackingUrlTemplate',
        'FinalUrlSuffix',
        'Path1',
        'Path2',
      ]);

      _.each(nullableArrayFields, (prop) => {
        if (_.isEmpty(params[prop])) {
          params[prop] = arrayEmptyValue;
        }
      });

      _.each(nullableStringFields, (prop) => {
        if (_.isEmpty(params[prop])) {
          params[prop] = stringEmptyValue;
        }
      });
    }

    return params;
  }

  // [TODO] need update
  handleApiErrors(errors) {
    const parsedErrors = _.map(errors, (error) => {
      if (_.has(error, 'property') && isCampaignEditorialError(error)) {
        // This mapping is for editorial errors. Once editorial is on boarded, will remove following mapping. See bug 576573.
        error.property = fieldMapping[error.property] || error.property;
      }
      return _.extend(error, {
        Property: error.property,
        Message: error.message,
        Code: error.code,
      });
    });

    this.apiErrors.push(...parsedErrors);
    this.render();
  }

  clearApiErrors() {
    this.apiErrors = [];
  }

  onChanged(ad) {
    this.cachedAd = ad;
  }

  triggerTestUurl() {
    return (fn, originalView) => this.trigger('testUurl', fn, originalView);
  }

  // Forcing the view to re-render with isSaving set to true and then false
  triggerSaving() {
    this.isSaving = true;
    this.render();
    this.isSaving = false;
    this.render();
  }

  triggerCanceling() {
    this.isCanceling = true;
    this.render();
    this.isCanceling = false;
    this.render();
  }

  /**
   * Render the view.
   * @return {View} This object.
   */
  render({ onFirstErrorHandler } = { onFirstErrorHandler: _.noop}) {
    // campaign id, ad group id will be changed when using campaign/adgroup selector
    this.adContext = {
      ...this.adContext,
      adGroupId: this.scope().adGroupId,
      campaignId: this.scope().campaignId,
    };

    ReactDOM.render(
      // eslint-disable-next-line no-extra-parens
      (
        <ThemeProvider theme={this.theme}>
          <InstrumentationContext.Provider value={this.instrumentation}>
            <PreferenceContext.Provider value={this.preferenceService || PreferenceService}>
              <I18nContext.Provider value={this.options.newI18n}>
                <ResponsiveSearchAdEditor
                  i18n={this.options.newI18n}
                  item={this.ad}
                  errors={this.apiErrors}
                  onChanged={_.bind(this.onChanged, this)}
                  onFetchAdStrengthV2={_.bind(this.fetchAdStrengthV2, this)}
                  onFetchDisclaimerInfo={_.bind(this.fetchDisclaimerInfo, this)}
                  showActionBar={false}
                  showInitialErrors={this.showInitialErrors}
                  timeZone={this.timeZone}
                  permissions={this.permissions}
                  token={pageContext.Token}
                  triggerTestUurl={this.triggerTestUurl()}
                  showUurlTestTool={true}
                  showFinalUrlSuffix={true}
                  showAdCustomizers={true}
                  showDynamicTextExtention={true}
                  edmCampaign={edm}
                  jsDataCampaign={jsdata}
                  isForVnext={true}
                  updateSuggestionMeasurement={_.bind(this.updateSuggestionMeasurement, this)}
                  saveLogAppliedSuggestionsFunc={_.bind(this.saveLogAppliedSuggestionsFunc, this)}
                  saveAssetLibraryEventHandler={_.bind(this.saveAssetLibraryEventHandler, this)}
                  // ImageExtensionsPane is depending on some stuff from legacy projects.
                  // Moreover, ResponsiveSearchAdEditor is also used by new expert sign-up, smart campaign etc.
                  // So use render prop to avoid introduce these legacy to ResponsiveSearchAdEditor
                  // Only enable this for ad create/edit panel in ads page
                  renderImageExtension={_.bind(this.renderImageExtension, this)}
                  injectSetPreviewImage={(cb) => {
                    this.setPreviewImageCallback = cb;
                  }}
                  activityLogger={this.activityLogger}
                  perfMarker={this.perfMarker}
                  scope={this.scope()}
                  serverContext={this.serverContext}
                  editMode={this.editMode}
                  isSaving={this.isSaving}
                  isCanceling={this.isCanceling}
                  onFirstErrorHandler={onFirstErrorHandler}
                >
                </ResponsiveSearchAdEditor>
              </I18nContext.Provider>
            </PreferenceContext.Provider>
          </InstrumentationContext.Provider>
        </ThemeProvider>
      ),
      this.el,
    );

    return this;
  }

  onPreviewImageChanged = (imageUrl) => {
    if (this.setPreviewImageCallback) {
      this.setPreviewImageCallback(imageUrl);
    }
  };

  onImageExtensionChanged = (changes) => {
    if (this.showImgExtWithoutAdGroupID && this.onCachedImageExtensionChanged) {
      this.onCachedImageExtensionChanged(changes);
    }
    this.cachedImageExtensionChanges = changes;
  };

  logImageExtensionUpdates({
    scope = {},
    adId,
    currentItems,
    createdExtModels,
    removedExtModels,
    updatedExtModels,
  }) {
    const createdImageExtensionsIds = _.pluck(createdExtModels, 'Id');
    const removedImageExtensionsIds = _.pluck(removedExtModels, 'Id');
    const updatedImageExtensionsIds = _.filter(updatedExtModels, (ext) => ext.Id);
    let msgsArr = [
      `SavedAdId:${adId}`,
      `AdGroupId:${scope.adGroupId}`,
    ];

    let hasDisabledImages = false;
    const usedImagesSources = {};
    let previousExistingImgExtsCount = 0;

    for (let i = 0; i < _.size(currentItems); i += 1) {
      const item = currentItems[i];

      if (item.Id) {
        previousExistingImgExtsCount += 1;
      } else if (item.disabled) {
        hasDisabledImages = true;
      } else {
        usedImagesSources[item.source] = true;
      }
    }

    msgsArr.push(
      ...[
        `ExistingImgExtsCount:${previousExistingImgExtsCount + _.size(removedImageExtensionsIds)}`,
        `CreatedImgExtsIds:${createdImageExtensionsIds.join('-')}`,
        `RemovedImgExtsIds:${removedImageExtensionsIds.join('-')}`,
        `UpdatedImgExtsIds:${updatedImageExtensionsIds.join('-')}`,
      ],
    );

    _.each(usedImagesSources, (val, key) => {
      msgsArr.push(`UsedImageFrom${key}`);
    });

    msgsArr = _.compact(msgsArr.concat([
      hasDisabledImages && 'UsedImageFromDisabled',
    ]));

    this.logActivity(`${msgsArr.join(';')};`);
  }

  saveImageExtensionsToServer({ adId, perfMarker }) {
    const { newI18n } = this.options;

    this.logActivity('Check image extensions');

    const defaultParams = {
      where: {
        adGroupId: this.scope().adGroupId,
        adGroupName: this.scope().adGroupName,
        campaignId: this.scope().campaignId,
        campaignName: this.scope().campaignName,
      },
    };

    if (_.isEmpty(this.cachedImageExtensionChanges.added) &&
      _.isEmpty(this.cachedImageExtensionChanges.removed) && _.isEmpty(this.cachedImageExtensionChanges.updated)) {
      return Promise.resolve(true);
    }

    const saveImgsExtPerfMarker = perfMarker.createChild('Process_ImageExtensions_Success');

    saveImgsExtPerfMarker.willInit();

    const createImageExtensionsPromise = _.map(this.cachedImageExtensionChanges.added, (ext) => {
      return this.imageExtRepository.extension.create(ext);
    });

    return Promise.all(createImageExtensionsPromise)
      .then((newExtensions) => {
        const newExtIds = _.pluck(newExtensions, 'Id');

        _.each(this.cachedImageExtensionChanges.added, (item, index) => {
          item.Id = newExtIds[index];
        });

        let deletePromise = Promise.resolve(true);

        if (!_.isEmpty(this.cachedImageExtensionChanges.removed)) {
          deletePromise =
            this.imageExtRepository.association.destroyAll({
              where: {
                id: { in: _.pluck(this.cachedImageExtensionChanges.removed, 'Id') },
                ...defaultParams.where,
              },
            });
        }

        return deletePromise
          .then(() => {
            const params = {
              where: {
                id: { in: newExtIds },
                ...defaultParams.where,
              },
            };
            const updatePromise = _.map(this.cachedImageExtensionChanges.updated, (ext) => {
              return this.imageExtRepository.extension.update(ext);
            });

            return Promise.all(updatePromise).then(() => {
              return this.imageExtRepository.association.updateAll(null, params);
            });
          });
      })
      .then(() => {
        this.logActivity('Updated image extension successfully');
        saveImgsExtPerfMarker.done();
      })
      .catch((err) => {
        // do nothing, so that this is non-blocking
        this.logActivity(`Updated image extension with failures, err: ${JSON.stringify(err)}`);

        const pageName = `<b>${newI18n.getString(_TL_('Ads & extensions'))}</b>`;

        notificationApi.showWarning(newI18n.getString(
          _TL_('There were errors when processing your image extension updates. To ensure that all changes are up to date or to manually create a new image extension, review your image extensions in the {{page}} page.'),
          {
            page: pageName,
          }));
      })
      .finally(() => {
        this.logImageExtensionUpdates({
          adId,
          currentItems: this.cachedImageExtensionChanges.current,
          createdExtModels: this.cachedImageExtensionChanges.added,
          removedExtModels: this.cachedImageExtensionChanges.removed,
          updatedExtModels: this.cachedImageExtensionChanges.updated,
          scope: defaultParams.where,
        });
      });
  }

  renderImageExtension(extraInfo) {
    if (this.adContext.adGroupId || this.showImgExtWithoutAdGroupID) {
      const imagePathFromConfig = config.get('imagePath');

      return this.enableRSAExpansion && <ImageExtensionsPane
        i18n={this.options.newI18n}
        imageExtRepository={this.imageExtRepository}
        adContext={this.adContext}
        maxImageExtensionsPerAdGroup={this.maxImageExtensionsPerAdGroup}
        perfMarker={this.perfMarker}
        permissions={this.permissions}
        oDataConfig={this.oDataConfig}
        dataModelUtil={dataModelUtil}
        imagePath={imagePathFromConfig}
        cachedImageExtensionChanges={this.showImgExtWithoutAdGroupID ? this.cachedImageExtensionChanges : undefined}
        legacyI18n={this.legacyI18n}
        instrumentation={this.instrumentation}
        onPreviewImageChanged={this.onPreviewImageChanged}
        adCreatorScenario={instrumentationScenarios.RSA}
        onImageExtensionChanged={this.onImageExtensionChanged}
        logActivity={this.logActivity}
        dateFormat={this.dateFormat}
        timeZone={this.timeZone}
        activityLogger={this.activityLogger}
        isAADUser={this.serverContext && this.serverContext.IsAADUser}
        assetLibraryEventHandler={this.assetLibraryEventHandler}
        serverContext={this.serverContext}
        {...extraInfo}
      />;
    }

    return null;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
